export default __webpack_public_path__ + "static/media/book.aa922219.svg";